import { render } from "./AddSeatRow.vue?vue&type=template&id=bcd3823c&scoped=true"
import script from "./AddSeatRow.vue?vue&type=script&lang=js"
export * from "./AddSeatRow.vue?vue&type=script&lang=js"

import "./AddSeatRow.vue?vue&type=style&index=0&id=bcd3823c&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd3823c"]])

export default __exports__